<app-card-template [config]="finalCardConfig">
    <div class="audio-status">
        <span *ngIf="recordingState === recordStates.PLAYING" class="text-danger">Transmitiendo...</span>
        <span *ngIf="recordingState === recordStates.PAUSED" class="text-danger">Transmisión pausada...</span>
    </div>
        <app-action-loader [wrapperFullWidth]="true" #loadAudio>
            <div class="mailbox message-widget">
                <div class="audio-items">
                    <button
                        *ngIf="!recordingState || recordingState === recordStates.PAUSED"
                        mat-icon-button
                        color="primary"
                        class="m-r-5"
                        (click)="onPlayOrPauseRecording()"
                        [disabled]="loadAudio.isRunning || isDisabled"
                    >
                        <i class="fa fa-play-circle display-5"></i>
                    </button>
                    <button
                        *ngIf="recordingState === recordStates.PLAYING"
                        mat-icon-button
                        color="primary"
                        class="m-r-5"
                        (click)="onPlayOrPauseRecording()"
                    >
                        <i class="fa fa-pause-circle display-5"></i>
                    </button>
                    <button
                        *ngIf="recordingState !== recordStates.STOPED"
                        mat-icon-button
                        color="warn"
                        (click)="onStopRecording()"
                    >
                        <i class="fa fa-stop-circle display-5"></i>
                    </button>
                    <mat-form-field
                        *ngIf="recordingState === recordStates.STOPED && inputDevices && inputDevices.length > 0"
                        class="m-t-10"
                    >
                        <mat-select placeholder="Microfono" [(value)]="selectedAudio">
                            <mat-option *ngFor="let device of inputDevices" [value]="device.deviceId">
                                {{ device.label }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                    <audio [hidden]="true" id="audioSource" autoplay controls muted #audioSource></audio>
                </div>
            </div>
        </app-action-loader>
</app-card-template>
